module.exports = __webpack_public_path__ + "static/img/background.65c2e7c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/background.gif
// module id = VZ6R
// module chunks = 56